import axios from "axios";
import fileDownload from "js-file-download";
import { showToast } from "../../utils/commonHelper";
import { getCookie } from "../../utils/userHelper";
export const getResumeDetails = async (resumeId) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE}/library/resumes/${resumeId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching resume details:", error);
    showToast(error, "error");
    return [];
  }
};
export const getInterviewQuestions = async (resumeId) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE}/library/question-bank/${resumeId}`
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching interview questions:", error);
    showToast(error, "error");
    return [];
  }
};

export const download_file = async (fileURL) => {
  // console.log("file", fileURL);
  // fileURL =
  //   "https://resumly.s3.amazonaws.com/6751bd72da10276acf8dacad/67fd74fe70d8e6caa9d6c41c/MoezAli_Resume_SeniorDataAnalystPaymentSuccess_at_CheckoutLtd.docx";
  // Construct the final URL
  const url =
    process.env.REACT_APP_API_BASE + "/resumes/download?s3_url=" + fileURL;
  console.log("final", url);

  try {
    // Fetch the file data
    const token = getCookie("id_token");
    console.log("token", token);
    const response = await axios.get(url, {
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${token}`, // replace with your actual token variable
        "Content-Type": "application/json",
      },
    });

    // Extract the filename from the URL
    // const filename = getFileName(url);
    let filename =
      fileURL.substring(fileURL.lastIndexOf("/") + 1) || "default-filename";
    console.log("filename", filename);

    // Trigger file download
    fileDownload(response.data, filename);

    console.log("File downloaded successfully");
  } catch (error) {
    console.error("Error downloading file:", error);
    showToast(error, "error");
  }
};

export const resumeFeedbackToApi = async (resumeId, feedbackParam) => {
  try {
    const token = getCookie("id_token");
    const url = `${process.env.REACT_APP_API_BASE}/resumes/${resumeId}/feedback`;
    const body = {
      feedback_object: feedbackParam.feedback_object,
      feedback_score: feedbackParam.feedback_score,
      feedback_description: feedbackParam.feedback_description,
    };
    const response = await axios.post(url, body, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error sending resume feedback:", error);
    showToast(error, "error");
    return [];
  }
};
